import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  //  loginUser: string = this.auth.getName() ? this.auth.getName() : '';
  //  logininfo: Logininfo = this.auth.loginID;
  loginUser: string = '';
  logininfo: Logininfo;

  constructor(
    private router: Router,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.auth.sessionState.subscribe((logininfo: Logininfo) => {
      if (logininfo) {
        this.logininfo = logininfo;
        this.loginUser = this.logininfo.getName();
      }
    });

  }
	/*
	getName(): void {
		this.loginUser = this.auth.getName();
		console.log('name', this.loginUser);
	}
	*/

  //セッション消えないように仮で（＊画面再読み込みするとセッション切れる）
  //TOP
  to_top() {
    this.router.navigate(['/top/']);
  }
  //顧客入力画面
  c_input() {
    this.router.navigate(['/input/']);
  }
  //顧客検索画面
  c_search() {
    this.router.navigate(['/search/']);
  }

  //日報一覧画面
  day_list() {
    this.router.navigate(['/day-list/']);
  }
  //週報一覧画面
  report_list() {
    this.router.navigate(['/report-list/']);
  }
  //未割当一覧画面
  matching_list() {
    this.router.navigate(['/matching-list/']);
  }

  //契約進捗画面
  contract_list() {
    this.router.navigate(['/contract-list/']);
  }
  //予実一覧画面
  goal_list() {
    this.router.navigate(['/goal-list/']);
  }
  //予実一覧画面
  lost_analysis() {
    this.router.navigate(['/lost-analysis/']);
  }
  //売上集計画面
  summary() {
    this.router.navigate(['/summary/']);
  }

  //とち活関連
  business_operator() {
    this.router.navigate(['/business-operator/']);
  }

  //アンケート
  enquete() {
    this.router.navigate(['/enquete/']);
  }
  //アンケート管理
  enquete_setting() {
    this.router.navigate(['/enquete-setting/']);
  }

  //ユーザー管理
  user_management() {
    this.router.navigate(['/user-management/']);
  }
  //権限管理
  related() {
    this.router.navigate(['/related/']);
  }
  //コード管理
  item_setting() {
    this.router.navigate(['/item-setting/']);
  }
  //面談場所管理
  place_setting() {
    this.router.navigate(['/place/']);
  }
  //TOP検索条件
  search_top() {
    this.router.navigate(['/search-top/']);
  }

  //目標設定画面
  goal() {
    this.router.navigate(['/goal/']);
  }
  //日報設定画面
  day() {
    this.router.navigate(['/day/']);
  }
  //週報登録画面
  report_edit() {
    this.router.navigate(['/report-edit/']);
  }
  //ログアウト
  logout() {
    this.auth.logout();
    this.loginUser = "";
    this.router.navigate(['/login/']);
  }

  // 面談集計
  interview_list() {
    this.router.navigate(['/interview-list/']);
  }
}
